import { c as _c } from "react/compiler-runtime";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import type { Entry } from "contentful";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import type { TypeFaqItem, TypeFaqItemSkeleton } from "@/types/contentful/generated";
type FaqItemEntry = TypeFaqItem<undefined, string>;
export type ResolvedBlock = Entry<TypeFaqItemSkeleton, undefined, string>;
interface Props {
  items: FaqItemEntry[];
  columnId: string;
}
export function AccordionColumn(t0) {
  const $ = _c(7);
  const {
    items,
    columnId
  } = t0;
  if (items.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== columnId || $[1] !== items) {
    let t2;
    if ($[3] !== columnId) {
      t2 = (item, index) => {
        const itemKey = `${columnId}-${item.sys.id}-${index}`;
        const anchor = item.fields.anchorTag;
        return <AccordionItem key={itemKey} value={itemKey} className="border-neutral-200" {...anchor ? {
          id: anchor
        } : {}}><AccordionTrigger id={`${itemKey}-trigger`} aria-controls={`${itemKey}-content`} suppressHydrationWarning={true} className={"\n                font-semibold\n                text-2xl\n                hover:text-muted-foreground\n                hover:no-underline\n                focus-visible:ring-(--custom-outline)\n                focus-visible:rounded-md\n              "}>{item.fields.question}</AccordionTrigger><AccordionContent id={`${itemKey}-content`} aria-labelledby={`${itemKey}-trigger`} className="prose max-w-none text-base">{documentToReactComponents(item.fields.answer)}</AccordionContent></AccordionItem>;
      };
      $[3] = columnId;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = items.map(t2);
    $[0] = columnId;
    $[1] = items;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <Accordion type="multiple">{t1}</Accordion>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}